import React, { useRef, useEffect } from "react";
import WidgetRenderer from "./WidgetRenderer";

function RenderExistingWidget(props, info) {
  const childRef = useRef(null);

  useEffect(() => {
    if (info.widgetName && childRef) {
      let filterParameter = props.filterParams?.length > 0 ? "&filter=" + JSON.stringify(props.filterParams) : "";
      const fetchWidget = props.request.request
        ? () => props.request.request("v1", `analytics/widget/byName?name=${info.widgetName}&data=true` + filterParameter, {}, "get")
        : () => props.request.postDataRequest(`analytics/widget/byName?name=${info.widgetName}&data=true` + filterParameter);

      fetchWidget().then((response) => {
        const widgetData = props.request.request ? response.data : response;
        if (response.status === "success" && widgetData) {
          WidgetRenderer.render(
            { ...widgetData, element: childRef.current },
            undefined,
            props.filterParams,
            props.core,
            props.uuid,
            props.dashboardProps,
          );
        }
      });
    }
  }, []);

  return <div className="oxzion-widget-content" ref={childRef}></div>;
}

export default RenderExistingWidget;
